import {ISMU, ISMUWithFactsheetType, ISoilQueryPartial} from "../lt-ng/soil-information";
import {ISmuFactsheetService} from "../services/smap/smu-factsheet-service";
import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {Coordinate} from "ol/coordinate";
import {IReportFromUrlService} from "../services/smap/report-from-url-service";


interface SiblingResultBindings {
    sibling: ISoilQueryPartial;
}

class SiblingResultController implements ng.IComponentController, SiblingResultBindings {
    sibling: ISoilQueryPartial;
    teReoFactsheetUrl: string;
    teReoFactsheetParams: ISMUWithFactsheetType;
    pinCoordinate: Coordinate;

    constructor(protected reportFromUrlService: IReportFromUrlService, protected mapService: IMapService) {
    }

    public showTeReoFactsheet($event: ng.IAngularEvent) {
        $event.preventDefault();

        this.reportFromUrlService.showFactsheet(this.teReoFactsheetParams, this.pinCoordinate);

        return false;
    }

    [s: string]: any;
}

export class SiblingResult implements ng.IComponentOptions {
    public controller = ['reportFromUrlService', 'landcareMapService', SiblingResultController];
    public bindings = {
        sibling: '<',
        teReoFactsheetUrl: '<',
        teReoFactsheetParams: '<'
    };

    // public templateUrl = '/Partial/component/SiblingResult';
    public template = `
    <div uib-dropdown>
    <a ng-if="$ctrl.sibling.soilName && $ctrl.sibling.factSheetURL" href uib-dropdown-toggle=""
        title="Download soil factsheet">
        <h5 class="mar-bot-4">
            <i class="icon icon-file-pdf"></i>
            <ng-bind-html ng-bind-html="$ctrl.sibling.soilName"></ng-bind-html>
        </h5>
    </a>

    <ul class="dropdown-menu" uib-dropdown-menu>
        <li>
            <a
            lcr-analytics-event='{"category":"SMAP_FACTSHEET_IMPROVED", "label":"DOWNLOAD: {{$ctrl.sibling.improvedFactSheetURL}}"}'
            class="factsheet-link" ng-if="$ctrl.sibling.improvedFactSheetURL" ng-href="{{$ctrl.sibling.improvedFactSheetURL}}" target="_blank" title="Download soil factsheet">
                <i class="icon icon-file-pdf"></i>
                Download improved factsheet
            </a>
        </li>
        <li>
            <a ng-href="{{$ctrl.teReoFactsheetUrl}}"
               title="Show Soil Map Unit Factsheet"
               class="factsheet-link"
               lcr-analytics-event='{"category":"SMAP_FACTSHEET_TE_REO", "label":"View: {{$ctrl.teReoFactsheetUrl}}"}'
               ng-click="$ctrl.showTeReoFactsheet($event)"
               data-action="showSMUFactsheet"
            >
                <i class="icon icon-report-doc" style="font-size: 18px; position: relative; left: -2px;"></i>
                 Te reo Māori factsheet
            </a>
        </li>
        <li>
            <a
            lcr-analytics-event='{"category":"SMAP_FACTSHEET", "label":"DOWNLOAD: {{$ctrl.sibling.factSheetURL}}"}'
            class="factsheet-link" ng-if="$ctrl.sibling.factSheetURL" ng-href="{{$ctrl.sibling.factSheetURL}}" target="_blank" title="Download soil factsheet">
                <i class="icon icon-file-pdf"></i>
                Download classic factsheet
            </a>
        </li>
    </ul>
</div>
<h5 ng-if="!$ctrl.sibling.factSheetURL" ng-bind-html='$ctrl.sibling.soilName' class="mar-bot-4"></h5>

<p>
    <span>{{ $ctrl.sibling.description | replaceUnicode }}</span>
    <br>
    <span title="Area">Area: {{ $ctrl.sibling.proportion }}%</span>
    -
    Confidence: <span ng-class="$ctrl.sibling.confidenceClass">{{ $ctrl.sibling.confidence }}</span>
</p>`;

/**
 <p ng-if="$ctrl.sibling.description ">
 {{ isDefined($ctrl.sibling.value) ? $ctrl.sibling.description : '' | replaceUnicode }}
 <br ng-if="isDefined($ctrl.sibling.value) && $ctrl.sibling.description"/>
 {{ isDefined($ctrl.sibling.value) ? $ctrl.sibling.value : $ctrl.sibling.description | replaceUnicode }}
 </p>`
*/
}
